let arr = [
  '这款手机外形美观大方，屏幕显示很细腻，线性马达带来的音效非常棒，由一亿像素加持的相机在拍照方面非常给力，运营速度流畅无比，待机时间可以达到2-3天，满足我的工作需求了，商家服务很给力，特别周到，下次一定继续来买，感谢大家了！',
  '颜色挺不错的，到货很快，120真心好，照相效果也很棒！ 外形外观：喜欢 拍照效果：比我手上在用的强很多 还有充电贼快！',
  '外形外观：特别漂亮，非常喜欢 屏幕音效：音效更是没的说 非常好听 拍照效果：比我以前的手机好多了，真不愧是一亿像素！ 运行速度：运行速度对我来说更是足够 ！！ 待机时间：没有问题 ，电池容量大 其他特色：颜值特别漂亮，非常喜欢',
  '外形外观：高大上的外观，拿在手上有份量 屏幕音效：声音很大，放歌好听 拍照效果：当然没话说，1个亿！ 运行速度：不卡顿，爸爸用足够了',
  ' 外形外观：颜色也太好看了吧，颜色在不同光线下和不同角度下有不同的颜色，真的特别好看 屏幕音效：音效也特别好，声音很大 运行速度：打游戏也很nice，这两天一直在用这个手机玩游戏，真的体验感很好',
  '手机外观很漂亮， 音质好， 运行速度快， 4820 毫安的大电池， 杠杠的， 待机时间长， 商家送的东西超多， 手机买给老婆用的， 老婆很喜欢， 总之， 还是很满意的 ',
  '外形外观：好看舒服，精致 屏幕音效：效果很好，亮 拍照效果：太棒了 运行速度：流畅 待机时间：时间很好，非常满意 其他特色：功能全面',
];

export default arr;



// WEBPACK FOOTER //
// ./src/mock/comment.config.js